/**
 * Client-safe runtime config (env vars exposed to the browser).
 * All values come from import.meta.env; only VITE_* vars are available in Vite.
 * Must use direct import.meta.env.VITE_* references so Vite can inline them at build time.
 */

export function getPublicRuntimeConfig() {
  return {
    /** Backend API base URL */
    backendUrl: import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:8000',

    /** Show error boundary test UI when "true" */
    showErrorBoundaryTest: import.meta.env.VITE_SHOW_ERROR_BOUNDARY_TEST === 'true',

    /** Vite built-ins */
    dev: import.meta.env.DEV,
    prod: import.meta.env.PROD,
    mode: import.meta.env.MODE,
    baseUrl: import.meta.env.BASE_URL,
  };
}

export type PublicRuntimeConfig = ReturnType<typeof getPublicRuntimeConfig>;
